import { render, staticRenderFns } from "./PDFTranslateVisor.vue?vue&type=template&id=46c3c4fe&scoped=true&"
import script from "./PDFTranslateVisor.vue?vue&type=script&lang=js&"
export * from "./PDFTranslateVisor.vue?vue&type=script&lang=js&"
import style0 from "./PDFTranslateVisor.vue?vue&type=style&index=0&id=46c3c4fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c3c4fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VContainer,VDialog,VFlex,VIcon,VLayout})
